import { Controller } from 'stimulus';

const ACTIVE = ['border-gray-700', 'bg-gray-100', 'text-gray-900', 'ring-2', 'ring-gray-700'];
const INACTIVE = ['border-gray-300', 'bg-white', 'text-gray-500'];

// Shows one panel at a time; none until a tab is chosen. Each tab is paired with the panel at the same index.
export default class TabsController extends Controller {
  static targets = ['tab', 'panel'];
  static values = { index: { type: Number, default: -1 } };

  connect() {
    this.render();
  }

  select(event) {
    event.preventDefault();
    this.indexValue = this.tabTargets.indexOf(event.currentTarget);
  }

  indexValueChanged() {
    this.render();
  }

  render() {
    this.tabTargets.forEach((tab, i) => {
      const active = i === this.indexValue;
      tab.setAttribute('aria-selected', active);
      tab.classList.remove(...(active ? INACTIVE : ACTIVE));
      tab.classList.add(...(active ? ACTIVE : INACTIVE));
    });
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== this.indexValue;
    });
  }
}
